exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".statistic[data-v-267591c4]{min-height:150px}", ""]);

// exports
